const WIDGET_URL = "https://widget.intercom.io/widget/";

let stopped = false;

// Mirrors Intercom's install snippet: queue calls until the widget script takes over window.Intercom.
function loadWidget(appId) {
  if (window.Intercom) return;

  const queue = (...args) => queue.q.push(args);
  queue.q = [];
  window.Intercom = queue;

  const script = document.createElement("script");
  script.async = true;
  script.src = `${WIDGET_URL}${appId}`;
  document.head.appendChild(script);
}

export function bootIntercom(appId, settings) {
  if (stopped) return;

  loadWidget(appId);
  window.Intercom("boot", { app_id: appId, ...settings });
}

export function updateIntercom(settings) {
  window.Intercom?.("update", settings);
}

export function showIntercom() {
  window.Intercom?.("show");
}

export function shutdownIntercom() {
  window.Intercom?.("shutdown");
}

// For logout and Company switch, which leave the page: a user response that lands
// before unload would otherwise boot the old User's Messenger again.
export function stopIntercom() {
  stopped = true;
  shutdownIntercom();
}
